import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { getSessionByCode, getSessions } from '../../services/session.service';

export const storeName = 'sessionEntity';

export const sessionEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: { ...baseEntity },
  effects: (dispatch: RematchDispatch<typeof sessionEntity>) => ({
    async fetchSessions(payload) {
      const resp = await getSessions(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saves(data.content);
      return resp;
    },

    async fetchSession(payload) {
      const resp = await getSessionByCode(payload);
      if (!resp) return null;

      const { data } = resp;
      this.saves([data]);
      return resp;
    },
  }),
});

export default sessionEntity;
